module.exports = __webpack_public_path__ + "img/cinema_3.caf3bed4.png";